import imgFormat from "@/filter/imgFormat";
const install = function (Vue, opts) {
  Vue.filter("imgFormat", imgFormat.imgFormat);
};
export default { install };
